import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: space-around;
  }
  align-items: center;
  align-content: center;
  justify-content: space-between;
  div {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 12px;
  justify-content: space-between;
`;

export const Social = styled.div`
  display: flex;
  flex-direction: row;
  opacity: 0.6;
  transition: 0.3s ease-in-out;

  :hover {
    opacity: 1;
  }
  a { 
    text-decoration: none; 
    color: #000;
    font-family: Rockwell, sans-serif;
    text-transform: lowercase;
    font-weight: lighter;
  }
  img {
    margin-right: 2px;
    width: auto;
    height: 20px;
  }
`;
